// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.message-reactions{display:flex;align-items:center;border-radius:16px;font-size:12px;font-style:normal;font-weight:400;line-height:normal;padding:0px 4px;width:auto;background-color:#f8f9fa;position:absolute;right:4px}.message-reactions>span{padding:2px 2px}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
